export default __webpack_public_path__ + "static/media/logo-us-Claires.3b5ca8a0.svg";